import React from 'react';
import { cxBool } from '@beef/utils';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { OffsetContainer } from "../OffsetContainer";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    className = _ref.className,
    isError = _ref.isError;
  var _positionX$positionY = {
      positionX: isError ? 145 : 103,
      positionY: -10
    },
    positionX = _positionX$positionY.positionX,
    positionY = _positionX$positionY.positionY;
  return /*#__PURE__*/React.createElement(OffsetContainer, {
    className: className,
    offset: [positionX, positionY],
    position: "top left",
    "data-t-id": "components-Tooltip"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('component', cxBool({
      isError: isError
    })),
    "data-t-id": "components-Tooltip"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('arrow')
  }), children));
};
Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string,
  isError: PropTypes.bool
} : {};